/* utils/sanitizeCoords.ts -------------------------------------------- */
export function sanitizeCoords(raw: any[]): number[][] {
  return sanitizedIndices(raw).map((index) => [...raw[index]]); // keep z if present
}

/** The indices of `raw` that `sanitizeCoords` keeps, in order. */
export function sanitizedIndices(raw: any[]): number[] {
  const kept: number[] = [];
  raw.forEach((c, index) => {
    if (
      Array.isArray(c) &&
      c.length >= 2 &&
      Number.isFinite(c[0]) &&
      Number.isFinite(c[1])
    ) {
      const prev = kept.length > 0 ? raw[kept[kept.length - 1]] : null;
      if (!prev || prev[0] !== c[0] || prev[1] !== c[1]) {
        kept.push(index);
      }
    }
  });
  return kept;
}
